export default {
  updateAll(state, value) {
    state.all = value
  },
  updateSingle(state, value) {
    state.single = value
  },
  updateMetaDataColumns(state, value) {
    state.metaDataColumns = value
  },
  setBatchEmails: (state, payload) => (state.batchEmails = payload.result)
}
